import React from 'react';
import classnames from 'classnames';
import styles from '../../styles/scss/components/tips/hero.module.scss';

// Fallback images
const FALLBACK_DESKTOP_IMAGE = '/img/tips-page/tips-hero-desktop.png';
const FALLBACK_MOBILE_IMAGE = '/img/tips-page/tips-hero-mobile.png';

const Hero = ({ title = '', image, mobileimage, className, ...rest }) => {
  // Use fallback images if none are provided
  const desktopImage = image || FALLBACK_DESKTOP_IMAGE;
  const mobileImage = mobileimage || FALLBACK_MOBILE_IMAGE;
  
  return (
    <div className={classnames(styles.wrapper, className)} {...rest}>
      <div className={styles.heroImageContainer}>
        <img 
          src={mobileImage} 
          alt={title} 
          className={styles.mobileImage} 
        />
        <img 
          src={desktopImage} 
          alt={title} 
          className={styles.desktopImage} 
        />
      </div>
      {title && (
        <div className={styles.titleContainer}>
          <h1 className={styles.titleText}>{title}</h1>
        </div>
      )}
      <div className={styles.yellowBorderBottom}></div>
    </div>
  );
};

export default Hero;
